import { ITranslations } from 'types/common';
import { StatusCellTransFields } from './types';
import en from 'translations/en/statusCell.json';
import pl from 'translations/pl/statusCell.json';
import sl from 'translations/sl/statusCell.json';

export const statusCellTranslations: ITranslations<StatusCellTransFields> = {
  name: 'statusCell',
  en,
  pl,
  sl,
};
